module.exports = __webpack_public_path__ + "files/96602c9ee8b663266bde46859cafef9d.svg";